export default "__VITE_PUBLIC_ASSET__a923b5a6__"